/* ===== i18n helper (global — folosit din mai multe IIFE-uri de mai jos) =====
   Filtrul liquid | t HTML-escapează valorile (ex. ' → &#39;), deci decodăm
   entitățile la citire. Returnează fallback-ul RO dacă cheia lipsește. */
window.naraT = function (key, fallback) {
  var v = window.naraI18n && window.naraI18n[key];
  if (!v) return fallback;
  var d = document.createElement('textarea');
  d.innerHTML = v;
  return d.value;
};

/* ===== theme.liquid L316-329 ===== */
(function(){
      document.addEventListener('DOMContentLoaded', function() {
        var rte = document.querySelector('.shopify-policy__body .rte');
        if (!rte) return;
        var h5s = rte.querySelectorAll('h5');
        h5s.forEach(function(el) {
          var text = el.textContent.trim();
          // Match numbered patterns like "1.", "2.", "10." at the start
          if (/^\d+\./.test(text)) {
            el.classList.add('policy-section-title');
          }
        });
      });
})();
/* ===== theme.liquid L806-852 ===== */
(function(){
  (function () {
    function splitAtDash(el, subClass) {
      if (!el || el.dataset.splitDone === "1") return;
      var text = el.textContent || "";
      // Find the first dash separator (–, —, or -)
      var dashMatch = text.match(/^(.*?)\s*[\-–—]\s*(.+)$/);
      if (!dashMatch) return;

      var mainText = dashMatch[1].trim();
      var subText = dashMatch[2].trim();

      el.textContent = mainText + " ";
      var sub = document.createElement("span");
      sub.className = subClass;
      sub.textContent = subText;
      el.appendChild(sub);
      el.dataset.splitDone = "1";
    }

    function run() {
      // 1) LISTING / COLLECTION cards
      document.querySelectorAll('div[class*="product_title"] p').forEach(function(p) {
        splitAtDash(p, "listing-title-sub");
      });

      // 2) PDP (product detail page)
      if (location.pathname.startsWith("/products/")) {
        var h1 = document.querySelector("h1");
        if (h1) splitAtDash(h1, "pdp-title-sub");
      }
    }

    document.addEventListener("DOMContentLoaded", run);

    // PERF: re-run on dynamic content changes via the shared document-wide
    // observer at the bottom of this file (see __naraSharedObserverTasks),
    // instead of a dedicated MutationObserver per feature.
    window.__naraSharedObserverTasks = window.__naraSharedObserverTasks || [];
    window.__naraSharedObserverTasks.push(run);
  })();
})();
/* ===== theme.liquid L981-1062 ===== */
(function(){
  (() => {
    const SAMPLE_PROP = "_free_sample";
    const NOTICE_TEXT = window.naraT("samplesRemoved", "Am eliminat mostrele gratuite deoarece pot fi comandate doar împreună cu un produs în coș.");

    async function getCart() {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      return res.json();
    }

    // Handle-uri care nu respecta tiparul mostra/mostre
    const EXTRA_SAMPLE_HANDLES = ["petiteknit-double-sunday-1"];

    function isSampleItem(item) {
      const p = item && item.properties;
      if (p && (p[SAMPLE_PROP] === true || p[SAMPLE_PROP] === "true" || p[SAMPLE_PROP] === 1 || p[SAMPLE_PROP] === "1")) {
        return true;
      }

      // Proprietatea `_free_sample` se pune intr-un singur loc, blocks/add-to-cart.liquid,
      // si numai pentru produsele cu tagul `sample`. O mostra adaugata pe alta cale ramanea
      // invizibila aici si era prinsa doar de samples-guard.js. Verificarea pe handle e
      // preluata de acolo: e la fel de sigura si e imuna la limba, fiindca titlurile se
      // traduc pe /en /bg /hu, dar handle-ul nu.
      const h = (item && item.handle || "").toLowerCase();
      return h.startsWith("mostra") || h.startsWith("mostre") || EXTRA_SAMPLE_HANDLES.includes(h);
    }

    async function removeItemByKey(key) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    function showNoticeOnce() {
      if (document.querySelector("[data-sample-enforced-notice]")) return;

      const el = document.createElement("div");
      el.setAttribute("data-sample-enforced-notice", "true");
      el.style.cssText = "margin:12px 0;padding:10px 12px;border:1px solid rgba(0,0,0,.15);font-size:14px;line-height:1.3;";
      el.textContent = NOTICE_TEXT;

      const target =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification") ||
        document.querySelector("main") ||
        document.body;

      target.prepend(el);
    }

    async function enforceSamplesRule() {
      const cart = await getCart();
      const items = cart.items || [];
      if (!items.length) return;

      const hasNonSample = items.some(it => !isSampleItem(it));
      const sampleItems = items.filter(isSampleItem);

      if (!hasNonSample && sampleItems.length) {
        for (const it of sampleItems) {
          await removeItemByKey(it.key);
        }

        showNoticeOnce();
        window.location.reload();
      }
    }

    document.addEventListener("DOMContentLoaded", () => {
      // Cos gol inseamna ca nu exista mostre de scos, deci nu are rost sa cerem /cart.js.
      if (window.naraCartIsEmpty && window.naraCartIsEmpty()) return;
      enforceSamplesRule().catch(() => {});
    });

    const _fetch = window.fetch;
    window.fetch = async function(input, init) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const isCartCall =
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear");

      const res = await _fetch.apply(this, arguments);

      if (isCartCall) {
        setTimeout(() => { enforceSamplesRule().catch(() => {}); }, 150);
      }

      return res;
    };
  })();
})();
/* ===== theme.liquid L1068-1075 ===== */
(function(){
  (function() {
    // Upgrade video preload strategy for smoother autoplay
    document.querySelectorAll('video[autoplay][preload="metadata"]').forEach(function(v) {
      v.preload = 'auto';
    });
  })();
})();
/* ===== theme.liquid L1081-1276 ===== */
(function(){
  (() => {
    const MAX_MOSTRE = 3;
    // Handles that don't follow the mostra/mostre prefix pattern
    const EXTRA_MOSTRE_HANDLES = ["petiteknit-double-sunday-1"];

    function isMostreHandle(handle) {
      const h = (handle || "").toLowerCase();
      return h.startsWith("mostra") || h.startsWith("mostre") || EXTRA_MOSTRE_HANDLES.includes(h);
    }

    function isMostrePage() {
      const handle = (window.location.pathname.split("/products/")[1] || "").split("?")[0].split("/")[0];
      return isMostreHandle(handle);
    }

    async function countMostreInCart() {
      try {
        const res = await fetch("/cart.js", { credentials: "same-origin" });
        const cart = await res.json();
        let count = 0;
        (cart.items || []).forEach(item => {
          if (isMostreHandle(item.handle)) {
            count += item.quantity;
          }
        });
        return count;
      } catch(e) { console.error(e); return 0; }
    }

    function applyLimit(remaining) {
      const atLimit = remaining <= 0;
      // Broadened selector: any quantity input on the page (PDP usually has just one main one)
      const qtyInput = document.querySelector('input[name="quantity"], .quantity__input, .js-qty__num');

      // 1. Cap the quantity input value (NO max attribute — avoids form validation errors)
      if (qtyInput) {
        const val = parseInt(qtyInput.value, 10) || 1;
        if (atLimit) {
          qtyInput.value = 0;
          qtyInput.readOnly = true;
          qtyInput.style.opacity = "0.4";
        } else if (val > remaining) {
          qtyInput.value = remaining;
          qtyInput.readOnly = false;
          qtyInput.style.opacity = "";
        } else {
          qtyInput.readOnly = false;
          qtyInput.style.opacity = "";
        }
      }

      // 2. + button: disable when at limit or when value >= remaining
      const plusBtn = document.querySelector('button[name="plus"], .quantity-plus, .plus, .js-qty__adjust--plus');
      if (plusBtn) {
        const currentVal = qtyInput ? parseInt(qtyInput.value, 10) : 0;
        const disablePlus = atLimit || currentVal >= remaining;
        plusBtn.disabled = disablePlus;
        plusBtn.style.opacity = disablePlus ? "0.3" : "";
        plusBtn.style.pointerEvents = disablePlus ? "none" : "";
      }

      // 3. - button: disable at minimum
      const minusBtn = document.querySelector('button[name="minus"], .quantity-minus, .minus, .js-qty__adjust--minus');
      if (minusBtn && qtyInput) {
        const val = parseInt(qtyInput.value, 10);
        const disableMinus = val <= (atLimit ? 0 : 1);
        minusBtn.disabled = disableMinus;
        minusBtn.style.opacity = disableMinus ? "0.3" : "";
        minusBtn.style.pointerEvents = disableMinus ? "none" : "";
      }

      // 4. Add to Cart button
      const btns = document.querySelectorAll('button[name="add"], .add-to-cart-button, .product-form__submit');
      btns.forEach(btn => {
        // Find existing notice or create one
        let notice = btn.parentElement.querySelector("[data-mostre-limit-notice]");

        if (!notice && btns.length > 0) {
            // Find a suitable parent to append the notice (below buttons)
            const parent = btn.closest(".product-form__buttons") || btn.parentElement;
            if (parent) {
                // Check again in the parent context
                notice = parent.querySelector("[data-mostre-limit-notice]");
                if (!notice) {
                    notice = document.createElement("p");
                    notice.setAttribute("data-mostre-limit-notice", "true");
                    notice.style.cssText = "margin-top:10px;font-size:13px;line-height:1.4;transition:color 0.2s;";
                    parent.appendChild(notice);
                }
            }
        }

        if (atLimit) {
          btn.disabled = true;
          btn.style.opacity = "0.4";
          btn.style.cursor = "not-allowed";
          btn.style.pointerEvents = "none";

          if (notice) {
             // Scrierea in textContent inlocuieste nodul text chiar si cu ACELASI
             // continut, deci produce o mutatie childList care redeclanseaza
             // observerul de mai jos, care cere din nou /cart.js. Fara garda,
             // pagina de mostra face poll la nesfarsit cat timp e deschisa.
             var _msgLimit = window.naraT("samplesLimitReached", "Ai atins limita de [MAX] mostre în coș.").replace("[MAX]", MAX_MOSTRE);
             if (notice.textContent !== _msgLimit) notice.textContent = _msgLimit;
             notice.style.color = "#d32f2f"; // Red
             notice.style.fontWeight = "500";
             notice.style.backgroundColor = "";
             notice.style.border = "";
             notice.style.padding = "";
          }
        } else {
          btn.disabled = false;
          btn.style.opacity = "";
          btn.style.cursor = "";
          btn.style.pointerEvents = "";

          if (notice) {
             var _msgMax = window.naraT("samplesLimitMax", "Poți comanda maxim [MAX] mostre gratuite.").replace("[MAX]", MAX_MOSTRE);
             if (notice.textContent !== _msgMax) notice.textContent = _msgMax;
             notice.style.color = "#666"; // Neutral
             notice.style.fontWeight = "normal";
             notice.style.backgroundColor = "";
             notice.style.border = "";
             notice.style.padding = "";
          }
        }
      });

      // 5. Clean up old remaining notices if any
      const oldRemain = document.querySelector("[data-mostre-remaining]");
      if (oldRemain) oldRemain.remove();
    }

    // Watch the quantity input for manual changes and clamp
    let currentRemaining = MAX_MOSTRE;

    function watchQtyInput() {
      const qtyInput = document.querySelector('input[name="quantity"], .quantity__input, .js-qty__num');
      if (!qtyInput || qtyInput._mostreWatched) return;
      // ... (rest of function)
      qtyInput._mostreWatched = true;

      const clamp = () => {
        const max = Math.max(currentRemaining, 0);
        let val = parseInt(qtyInput.value, 10) || 0;
        if (val > max) { qtyInput.value = max; }
        // Re-check + button state after manual change
        const plusBtn = document.querySelector('button[name="plus"], .quantity-plus, .plus, .js-qty__adjust--plus');
        if (plusBtn) {
          const disablePlus = val >= max;
          plusBtn.disabled = disablePlus;
          plusBtn.style.opacity = disablePlus ? "0.3" : "";
          plusBtn.style.pointerEvents = disablePlus ? "none" : "";
        }
      };

      qtyInput.addEventListener("input", clamp);
      qtyInput.addEventListener("change", clamp);

      // Also listen to +/- buttons clicks if they exist
      const buttons = document.querySelectorAll('button[name="plus"], .quantity-plus, .plus, .js-qty__adjust--plus, button[name="minus"], .quantity-minus, .minus, .js-qty__adjust--minus');
      buttons.forEach(btn => {
        btn.addEventListener("click", () => setTimeout(clamp, 50)); // Small delay for value update
      });
    }

    async function enforceMostreLimit() {
      if (!isMostrePage()) return;
      const inCart = await countMostreInCart();
      currentRemaining = MAX_MOSTRE - inCart;
      applyLimit(currentRemaining);
      watchQtyInput();
    }

    // ── MUTATION OBSERVER: Re-apply lock if the theme re-renders the input or buttons ──
    if (isMostrePage()) {
      const formObs = new MutationObserver(function(mutations) {
        // Debounce slightly or just run
         enforceMostreLimit();
      });
      document.addEventListener("DOMContentLoaded", function() {
        // Observe the main product info area for re-renders (e.g. variant changes)
        const productInfo = document.querySelector("product-info, .product-info, main, #MainContent, .product__info-container") || document.body;
        formObs.observe(productInfo, { childList: true, subtree: true });
        enforceMostreLimit();
      });
    }

    // Re-check after any cart mutation
    const _origFetch = window.fetch;
    window.fetch = async function(input, init) {
      const res = await _origFetch.apply(this, arguments);
      const url = typeof input === "string" ? input : (input && input.url) || "";
      if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update")) {
        setTimeout(enforceMostreLimit, 500);
      }
      return res;
    };
  })();
})();
/* ===== theme.liquid L1340-1366 ===== */
(function(){
  document.addEventListener('DOMContentLoaded', function() {
    // Formularul de gift card exista doar pe PDP-ul de gift card si e randat de
    // server. Fara garda asta, observerul de mai jos cadea pe document.body cu
    // subtree:true pe TOATE paginile magazinului si rula querySelectorAll la
    // fiecare mutatie, degeaba.
    if (!document.querySelector('gift-card-recipient-form')) return;

    function setupGiftCardForm() {
      var forms = document.querySelectorAll('gift-card-recipient-form');
      forms.forEach(function(form) {
        // Auto-select recipient radio
        var recipientRadio = form.querySelector('input[id*="Recipient-email-button"]');
        if (recipientRadio && !recipientRadio.checked) {
          recipientRadio.checked = true;
          recipientRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Add title above recipient fields if not already present
        var fields = form.querySelector('.recipient-fields');
        if (fields && !form.querySelector('[data-recipient-form-title]')) {
          var title = document.createElement('p');
          title.setAttribute('data-recipient-form-title', 'true');
          title.textContent = window.naraT('giftRecipientTitle', 'Adaugă detaliile destinatarului');
          fields.parentElement.insertBefore(title, fields);
        }
      });
    }
    setupGiftCardForm();
    var obs = new MutationObserver(setupGiftCardForm);
    var target = document.querySelector('product-info') || document.body;
    obs.observe(target, { childList: true, subtree: true });
  });
})();
/* ===== theme.liquid L1411-1506 ===== */
(function(){
  (() => {
    /* Pragul de transport gratuit e definit în LEI în Shopify: 300 pe România,
       400 pe Ungaria și Bulgaria. Coșul din /cart.js vine însă în valuta pieței,
       așa că aducem pragul în aceeași valută cu rata Shopify. Fără asta, pe HU
       se compara un coș în forinți cu un prag în lei și bara anunța transport
       gratuit de la 300 Ft. */
    const NARA_MKT = (function () {
      var sc = (window.Shopify && window.Shopify.currency) || {};
      var code = sc.active || 'RON';
      return {
        code: code,
        rate: parseFloat(sc.rate || '1') || 1,
        country: (window.Shopify && window.Shopify.country) || 'RO',
        unit: { RON: 'lei', HUF: 'Ft', EUR: '€' }[code] || code,
        dec: code === 'HUF' ? 0 : 2,
        loc: code === 'HUF' ? 'hu-HU' : (code === 'EUR' ? 'bg-BG' : 'ro-RO')
      };
    })();
    const FREE_SHIPPING_THRESHOLD_LEI = { RO: 30000, HU: 40000, BG: 40000 }[NARA_MKT.country] || 50000;
    const FREE_SHIPPING_THRESHOLD = Math.round(FREE_SHIPPING_THRESHOLD_LEI * NARA_MKT.rate);

    function createBarHTML() {
      return `
        <div class="fs-bar-wrap" id="fs-progress-bar">
          <div class="fs-bar-msg" id="fs-bar-msg"></div>
          <div class="fs-bar-track">
            <div class="fs-bar-fill" id="fs-bar-fill" style="width:0%"></div>
          </div>
        </div>`;
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(NARA_MKT.loc, {
        minimumFractionDigits: NARA_MKT.dec,
        maximumFractionDigits: NARA_MKT.dec
      }) + ' ' + NARA_MKT.unit;
    }

    // Traducerile sunt plain-text ([[...]] marchează porțiunea accentuată);
    // escapăm totul și abia apoi generăm <span>-ul, ca să nu injectăm HTML din locale.
    function naraFsMarkup(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML.replace(/\[\[(.+?)\]\]/g, '<span>$1</span>');
    }

    function updateBar(totalCents) {
      const bar = document.getElementById('fs-progress-bar');
      if (!bar) return;
      const fill = document.getElementById('fs-bar-fill');
      const msg = document.getElementById('fs-bar-msg');
      const wrap = document.getElementById('fs-progress-bar');

      const pct = Math.min((totalCents / FREE_SHIPPING_THRESHOLD) * 100, 100);
      fill.style.width = pct + '%';

      if (totalCents >= FREE_SHIPPING_THRESHOLD) {
        wrap.classList.add('fs-bar--done');
        msg.innerHTML = naraFsMarkup(window.naraT('freeShippingDone', '✓ Ai transport [[gratuit]]!'));
      } else {
        wrap.classList.remove('fs-bar--done');
        const remaining = FREE_SHIPPING_THRESHOLD - totalCents;
        msg.innerHTML = naraFsMarkup(window.naraT('freeShippingRemaining', 'Mai ai [[[AMOUNT]]] până la livrare gratuită.').replace('[AMOUNT]', formatMoney(remaining)));
      }
    }

    async function fetchAndUpdate() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await res.json();
        updateBar(cart.total_price || 0);
      } catch(e) { /* silent */ }
    }

    function injectBar() {
      // Find the cart drawer (theme uses cart-drawer-component)
      const drawer = document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer');
      if (!drawer) return false;
      // Don't inject twice
      if (document.getElementById('fs-progress-bar')) return true;
      // Find the header inside the drawer
      const header = drawer.querySelector('.cart-drawer__header');
      if (header) {
        header.insertAdjacentHTML('afterend', createBarHTML());
      } else {
        // Fallback: insert at the beginning of .cart-drawer__inner or drawer itself
        const inner = drawer.querySelector('.cart-drawer__inner') || drawer;
        inner.insertAdjacentHTML('afterbegin', createBarHTML());
      }
      return true;
    }

    function init() {
      if (!injectBar()) return;
      // Cos gol: stim deja totalul, e 0. Nu are rost inca un GET /cart.js pe fiecare
      // pagina din magazin doar ca sa aflam asta.
      if (window.naraCartIsEmpty && window.naraCartIsEmpty()) {
        updateBar(0);
        return;
      }
      fetchAndUpdate();
    }

    // Run on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', init);

    // Watch for cart drawer opening (it may be lazy-loaded)
    // Observerul cade pe document.body cu subtree:true, deci se declanseaza la
    // fiecare rafala de mutatii din pagina. Batch pe un singur cadru: fara asta
    // getElementById rula de zeci de ori pe cadru pe colectii mari.
    let drawerScheduled = false;
    const drawerObs = new MutationObserver(() => {
      if (drawerScheduled) return;
      drawerScheduled = true;
      requestAnimationFrame(() => {
        drawerScheduled = false;
        if (!document.getElementById('fs-progress-bar')) {
          if (injectBar()) {
            if (window.naraCartIsEmpty && window.naraCartIsEmpty()) updateBar(0);
            else fetchAndUpdate();
          }
        }
      });
    });
    drawerObs.observe(document.body, { childList: true, subtree: true });

    // Intercept fetch to update bar after cart changes
    const _origFetch = window.fetch;
    window.fetch = function(...args) {
      const req = args[0] || '';
      const url = typeof req === 'string' ? req : (req.url || '');
      const res = _origFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        res.then(() => {
          setTimeout(fetchAndUpdate, 300);
        }).catch(() => {});
      }
      return res;
    };
  })();
})();
/* ===== theme.liquid L1633-1723 ===== */
(function(){
    /* ============================================================
       GLOBAL PRODUCT PAGE ENHANCEMENTS
       1. Vendor name injection
       2. Rogue "ramase in stoc" script neutralization
       3. Inventory display override
       ============================================================ */
    (function() {
      if (!window.location.pathname.startsWith('/products/')) return;

      /* ---------- HELPER: Find brand from ALL JSON-LD scripts ---------- */
      function findBrandName() {
        // 1. Try og:brand meta
        var m = document.querySelector('meta[property="og:brand"]');
        if (m && m.content) return m.content;

        // 2. Try ALL JSON-LD scripts
        var scripts = document.querySelectorAll('script[type="application/ld+json"]');
        for (var i = 0; i < scripts.length; i++) {
          try {
            var j = JSON.parse(scripts[i].textContent);
            if (j.brand && j.brand.name) return j.brand.name;
            // Some formats nest under @graph
            if (j['@graph']) {
              for (var k = 0; k < j['@graph'].length; k++) {
                var node = j['@graph'][k];
                if (node.brand && node.brand.name) return node.brand.name;
              }
            }
          } catch(e) {}
        }

        // 3. Try product JSON in variant picker
        try {
          var vpJson = document.querySelector('variant-picker script[type="application/json"]');
          if (vpJson) {
            var vd = JSON.parse(vpJson.textContent);
            // The variant name sometimes starts with vendor
            if (vd.vendor) return vd.vendor;
          }
        } catch(e) {}

        return null;
      }

      /* ---------- VENDOR INJECTION ---------- */
      function injectVendor() {
        if (document.querySelector('.product-vendor-injected')) return;

        var h1 = document.querySelector('h1');
        if (!h1) return;

        var brandName = findBrandName();
        if (!brandName) return;

        var vendorDiv = document.createElement('div');
        vendorDiv.className = 'product-vendor-injected';
        vendorDiv.textContent = brandName;
        vendorDiv.style.cssText = 'font-size:12px;margin-bottom:8px;color:rgba(var(--color-foreground),0.75);text-transform:uppercase;letter-spacing:1px;font-weight:500;';

        // Insert before the text-block div that wraps the H1
        var textBlock = h1.closest('.text-block');
        if (textBlock) {
          textBlock.parentNode.insertBefore(vendorDiv, textBlock);
        } else {
          h1.parentNode.insertBefore(vendorDiv, h1);
        }
      }


      /* ---------- RUN ---------- */
      function init() {
        injectVendor();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      // Also try after a short delay (some content loads asynchronously)
      setTimeout(function() {
        injectVendor();
      }, 1000);
    })();
})();
/* ===== theme.liquid L1729-1792 ===== */
(function(){
  (function() {
    function fixProductListCards() {
      var section = document.querySelector('[data-testid="product-list"]');
      if (!section) return;

      // Rulat din observerul partajat, deci de multe ori per pagina. `data-nara-fixed`
      // face fiecare element sa fie atins O SINGURA DATA: altfel se re-parsa
      // atributul style pentru ~300 de elemente la fiecare rafala de mutatii.
      // Stilurile raman inline (`!important` inline bate `!important` din
      // stylesheet, deci mutarea in CSS ar cobori specificitatea si ar strica grila).
      function fixEach(selector, css) {
        section.querySelectorAll(selector).forEach(function (el) {
          if (el.dataset.naraFixed === '1') return;
          el.dataset.naraFixed = '1';
          el.style.cssText += css;
        });
      }

      // Fix card gallery images: square aspect ratio
      fixEach('.card-gallery', 'aspect-ratio:1/1 !important;overflow:hidden !important;position:relative !important;');
      fixEach(
        '.card-gallery__media, .card-gallery__media img, .product-media__image',
        'width:100% !important;height:100% !important;object-fit:cover !important;display:block !important;'
      );

      // Fix card content: left-align text
      fixEach('.product-card__content', 'align-items:flex-start !important;text-align:left !important;padding-left:0 !important;');

      // Fix group-block-content: stack vertically
      fixEach('.group-block-content', 'flex-direction:column !important;align-items:flex-start !important;padding-left:0 !important;');

      // Fix price: left-align
      fixEach('product-price, .text-right', 'text-align:left !important;align-self:flex-start !important;width:auto !important;');

      // Fix text blocks: left-align
      fixEach('.text-block, rte-formatter.text-block', 'text-align:left !important;align-self:flex-start !important;margin-left:0 !important;');

      // Fix vendor label
      fixEach('.product-card-vendor', 'text-align:left !important;font-size:12px;');
    }

    // Run on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixProductListCards);
    } else {
      fixProductListCards();
    }

    // Re-run after delays (section may load asynchronously)
    setTimeout(fixProductListCards, 500);
    setTimeout(fixProductListCards, 1500);
    setTimeout(fixProductListCards, 3000);

    // PERF: catch dynamically loaded sections via the shared observer below.
    window.__naraSharedObserverTasks = window.__naraSharedObserverTasks || [];
    window.__naraSharedObserverTasks.push(fixProductListCards);
  })();
})();
/* ===== theme.liquid L1816-1863 ===== */
(function(){
  (function() {
    var FROM_RO = 'Alte opțiuni de conectare';
    var FROM_EN = 'Other login options';
    var TO_RO = 'Autentificare';
    var TO_EN = 'Sign in';

    function rename(root) {
      // Walk text nodes and replace exact matches
      var scope = root && root.nodeType === 1 ? root : document.body;
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
      var node;
      var changed = false;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue) continue;
        var val = node.nodeValue.trim();
        if (val === FROM_RO) {
          node.nodeValue = node.nodeValue.replace(FROM_RO, TO_RO);
          changed = true;
        } else if (val === FROM_EN) {
          node.nodeValue = node.nodeValue.replace(FROM_EN, TO_EN);
          changed = true;
        }
      }
      return changed;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rename);
    } else {
      rename();
    }
    // Re-run after delays since the popover/drawer may render later
    setTimeout(rename, 300);
    setTimeout(rename, 1000);
    setTimeout(rename, 2500);

    // PERF: catch any later DOM changes (popover open, drawer mount) via the
    // shared observer below.
    window.__naraSharedObserverTasks = window.__naraSharedObserverTasks || [];
    // Pasul REPETAT se scopeaza pe #account-popover: singurul nod care se
    // re-randeaza (morph.js il trateaza explicit). Un TreeWalker peste tot
    // document.body la fiecare cadru cu mutatii costa milisecunde pe colectii
    // mari. Pasajele initiale de mai sus raman pe tot body, deci sertarul
    // mobil si orice alt loc sunt in continuare acoperite la incarcare.
    window.__naraSharedObserverTasks.push(function () {
      rename(document.getElementById('account-popover'));
    });
  })();
})();
/* ===== theme.liquid L1900-1962 ===== */
(function(){
  (function() {
    // Run only on the /cart page (not on product or cart drawer)
    if (!/^\/(cart\/?|[a-z-]{2,5}\/cart\/?)$/.test(window.location.pathname)) return;

    // Klarna nu operează în Ungaria — pe piața HU nu promovăm Klarna deloc
    var naraCountry = window.naraCountry || (window.Shopify && window.Shopify.country) || '';
    if (naraCountry === 'HU') return;

    var KLARNA_BADGE_URL = '//naraknits.com/cdn/shop/files/Klarna_Payment_Badge_svg.webp?v=1775393477&width=400';
    var KLARNA_TEXT_RO = 'Plătești în rate sau cumperi acum și plătești în 30 de zile prin Klarna, cu 0% dobândă.';
    var KLARNA_TEXT_EN = 'Pay in installments or buy now and pay in 30 days with Klarna, 0% interest.';
    var lang = (document.documentElement.lang || 'ro').toLowerCase().split('-')[0];
    var text = lang === 'en' ? KLARNA_TEXT_EN : KLARNA_TEXT_RO;

    function findCheckoutButton() {
      return document.querySelector(
        'button[name="checkout"], ' +
        'a[href$="/checkout"], ' +
        'a[href*="/checkout?"], ' +
        '.cart__checkout-button, ' +
        '.cart-totals__submit, ' +
        '.cart__submit, ' +
        '[data-checkout-button]'
      );
    }

    function injectKlarna() {
      if (document.getElementById('cart-klarna-block')) return;

      var btn = findCheckoutButton();
      if (!btn) return;

      var block = document.createElement('div');
      block.id = 'cart-klarna-block';
      block.className = 'cart-klarna-block';
      block.innerHTML =
        '<img class="cart-klarna-block__badge" src="' + KLARNA_BADGE_URL + '" alt="Klarna" loading="lazy">' +
        '<p class="cart-klarna-block__text">' + text + '</p>';

      // Insert right after the checkout button
      if (btn.nextSibling) {
        btn.parentNode.insertBefore(block, btn.nextSibling);
      } else {
        btn.parentNode.appendChild(block);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectKlarna);
    } else {
      injectKlarna();
    }

    // PERF: re-inject if cart re-renders (qty change, item remove), via the
    // shared observer below. injectKlarna() is idempotent (no-ops if the
    // block already exists or we're not on /cart), so no extra guard needed.
    window.__naraSharedObserverTasks = window.__naraSharedObserverTasks || [];
    window.__naraSharedObserverTasks.push(injectKlarna);
  })();
})();

/* ===== PERF: single shared MutationObserver replacing 4 separate ones =====
   Each task above (title dash-split, collection-card fixes, login-label
   rename, cart Klarna badge) used to run its own MutationObserver on
   document.body/documentElement. They're now registered in
   window.__naraSharedObserverTasks and run from ONE observer + one
   rAF-debounced dispatch per mutation batch, instead of 4. Each task's own
   internal logic and idempotency checks are unchanged. */
(function () {
  var scheduled = false;
  function runAll() {
    (window.__naraSharedObserverTasks || []).forEach(function (fn) {
      try { fn(); } catch (e) { /* one task failing shouldn't block the rest */ }
    });
  }
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      runAll();
      scheduled = false;
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ===== Butonul de cumparare pierdut dupa o varianta epuizata (27.08.2026) =====
   Scriptul Klaviyo ("Anunta-ma cand revine in stoc") ascunde butonul nativ de
   adaugare in cos scriindu-i DIRECT pe element
   style="opacity:.35; pointer-events:none; display:none !important"
   cand varianta selectata e epuizata. La revenirea pe o varianta disponibila
   NU curata stilul: tema stie corect ca produsul e in stoc (linia de stoc revine,
   sticky-add-to-cart trece pe data-variant-available="true"), dar butonul ramane
   ascuns si clientul nu mai poate cumpara fara sa reincarce pagina. Masurat pe
   double-sunday: 13 secunde la rand fara buton. Se declanseaza cand clientul
   ZABOVESTE pe culoarea epuizata, adica destul cat Klaviyo sa apuce sa scrie
   stilul; la o trecere fulger prin culori nu apare.

   Un display:none !important scris inline nu poate fi invins din foaia de stil,
   deci partea asta trebuie facuta din JS. Perechea ei, ascunderea butonului
   Klaviyo ramas in urma, e o regula pura in nara-custom.css.

   Nu atingem nimic cat timp varianta chiar e epuizata, deci nu ne batem cu
   Klaviyo; corectam doar starea contradictorie "tema zice in stoc, butonul e
   ascuns". */
(function () {
  function variantAvailable() {
    // sursa primara: chiar atributul intretinut de tema
    var sticky = document.querySelector('sticky-add-to-cart[data-variant-available]');
    if (sticky) return sticky.getAttribute('data-variant-available') === 'true';
    // rezerva, daca bara sticky lipseste pe vreun sablon
    var inv = document.querySelector('product-inventory');
    if (inv) return !inv.querySelector('.product-inventory__icon-out_of_stock');
    return null; // nu stim -> nu atingem nimic
  }

  function restoreBuyButton() {
    if (variantAvailable() !== true) return;
    var block = document.querySelector('.buy-buttons-block');
    if (!block) return;
    var btn = block.querySelector('.add-to-cart-button');
    if (!btn || btn.style.getPropertyValue('display') !== 'none') return;
    btn.style.removeProperty('display');
    btn.style.removeProperty('opacity');
    btn.style.removeProperty('pointer-events');
  }

  // Klaviyo scrie stilul ASINCRON, dupa evenimentul de varianta, deci o singura
  // verificare imediata ar rata scrierea. Reverificam de cateva ori, ieftin.
  function scheduleChecks() {
    [0, 200, 500, 1000, 2000, 3500].forEach(function (ms) {
      setTimeout(restoreBuyButton, ms);
    });
  }

  document.addEventListener('variant:update', scheduleChecks);
  document.addEventListener('variant:selected', scheduleChecks);

  // Plasa de siguranta: observatorul partajat de la finalul fisierului ruleaza la
  // orice mutatie de structura, deci prinde si injectarea butonului Klaviyo.
  window.__naraSharedObserverTasks = window.__naraSharedObserverTasks || [];
  window.__naraSharedObserverTasks.push(restoreBuyButton);

  document.addEventListener('DOMContentLoaded', restoreBuyButton);
})();
